import React from 'react';
import { Features, CompleteVehicleEntry } from '@oneaudi/vtp-shared';
import Product from './Product';
import { ProductsContainer } from './styles';

export interface EquipmentsHighlightsProps {
  highlights: Features[];
  max: number;
  vehicleRaw: CompleteVehicleEntry;
}
const EquipmentsHighlights: React.FC<EquipmentsHighlightsProps> = (
  props: EquipmentsHighlightsProps
) => {
  const { highlights, max, vehicleRaw } = props;

  const highlightsSliced = highlights.slice(0, max);
  return (
    <ProductsContainer>
      {highlightsSliced.map((product) => {
        return <Product product={product} key={product.prno} vehicleRaw={vehicleRaw} />;
      })}
    </ProductsContainer>
  );
};

export default EquipmentsHighlights;
